import styled from 'styled-components';

export const AssessmentStandarContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100vh;
  align-items: center;
  background: ${({ theme }) => theme.colors.darkBlue};
  width: 100%;
`;

export const ContentArea = styled.div`
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 100px);
  background-color: ${({ theme }) => theme.colors.white};
  width: 100%;
  top: 200px;
  position: absolute;
  padding-bottom: 85px;
`;
